module.exports = __webpack_public_path__ + "img/header-img-v3.e8a5489e.jpg";